import React, { useState, useEffect } from 'react';
import { postAPI } from '../../app/api';
import { setStore, removeStore, store } from '../../app/store';
import Swal from 'sweetalert2';
import '@fortawesome/fontawesome-free/css/all.min.css';
import memberIcon from "../../theme/assets/images/icon/member-icon.svg"
import logo from "../../assets/img/logo.png"

const { REACT_APP_BRANDURL } = process.env;

export default function Header() {
    // Forgot Password Modal State
    const [showForgotModal, setShowForgotModal] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [forgotLoading, setForgotLoading] = useState(false);
    const [forgotError, setForgotError] = useState("");
    const [forgotSuccess, setForgotSuccess] = useState("");
    const [forgotCooldown, setForgotCooldown] = useState(0);

    // Change Password Modal State
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [changePasswordData, setChangePasswordData] = useState({
        old_password: '',
        new_password: '',
        current_password: ''
    });
    const [changePasswordLoading, setChangePasswordLoading] = useState(false);
    const [showPasswords, setShowPasswords] = useState({
        old: false,
        new: false,
        confirm: false
    });

    // Cooldown timer effect
    useEffect(() => {
        if (forgotCooldown > 0) {
            const timer = setTimeout(() => setForgotCooldown(forgotCooldown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [forgotCooldown]);

    const handleForgotSubmit = async (e) => {
        e.preventDefault();
        if (forgotCooldown > 0) return; // Prevent submit during cooldown

        setForgotLoading(true);
        setForgotError("");
        setForgotSuccess("");
        try {
            const response = await postAPI("/authentication/users/forget-password", { email: forgotEmail });
            if (response?.status === 1) {
                setForgotSuccess("A new password has been sent to your email.");
                setForgotCooldown(60); // 60 second cooldown after success
            } else {
                setForgotError(response?.message || "User doesn't exist");
            }
        } catch (err) {
            setForgotError("Something went wrong. Please try again.");
        }
        setForgotLoading(false);
    };

    // Change Password Functions
    const handleChangePasswordSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        if (!changePasswordData.old_password.trim()) {
            Swal.fire('Validation Error', 'Please enter your current password', 'warning');
            return;
        }
        if (!changePasswordData.new_password.trim()) {
            Swal.fire('Validation Error', 'Please enter a new password', 'warning');
            return;
        }
        if (!changePasswordData.current_password.trim()) {
            Swal.fire('Validation Error', 'Please confirm your new password', 'warning');
            return;
        }
        if (changePasswordData.new_password !== changePasswordData.current_password) {
            Swal.fire('Validation Error', 'New password and confirmation do not match', 'warning');
            return;
        }
        if (changePasswordData.new_password.length < 6) {
            Swal.fire('Validation Error', 'New password must be at least 6 characters long', 'warning');
            return;
        }

        setChangePasswordLoading(true);
        try {
            const response = await postAPI('/authentication/users/update-password', {
                user_type: store_data?.user_type || 'ALUMNI',
                username: store_data?.email_id,
                old_password: changePasswordData.old_password,
                new_password: changePasswordData.new_password,
                current_password: changePasswordData.current_password
            });

            if (response?.status === 1) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Password updated successfully',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    // Reset form and close modal
                    setChangePasswordData({
                        old_password: '',
                        new_password: '',
                        current_password: ''
                    });
                    setShowChangePasswordModal(false);
                });
            } else {
                Swal.fire('Error', response?.msg || 'Failed to update password', 'error');
            }
        } catch (error) {
            console.error('Change password error:', error);
            Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
        }
        setChangePasswordLoading(false);
    };

    const handleChangePasswordInputChange = (e) => {
        const { name, value } = e.target;
        setChangePasswordData({
            ...changePasswordData,
            [name]: value
        });
    };

    const togglePasswordVisibility = (field) => {
        setShowPasswords({
            ...showPasswords,
            [field]: !showPasswords[field]
        });
    };
    const [navBg, setNavBg] = useState(false);
    const [FormData, setFormData] = useState({
        user_type: 'ALUMNI',
        username: '',
        password: ''
    });
    const store_data = JSON.parse(store());
    const [Loading, setLoading] = useState(false);
    const [LoginStatus, setLoginStatus] = useState(0);

    // console.log(store_data);

    useEffect(() => {
        console.log(store_data)
        setLoginStatus(store_data?.is_login || 0)
    }, [store_data?.is_login || 0])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...FormData,
            [name]: value
        });
    }

    const handleLogin = async () => {
        try {
            // Validate form
            if (!FormData.username || !FormData.password) {
                Swal.fire({
                    title: "Sorry!",
                    text: "Please enter username and password",
                    icon: "error"
                });
                // Keep LoginStatus as 0 on validation error
                return;
            }

            setLoading(true);
            const response = await postAPI(`authentication/users/login`, FormData);

            console.log("Response : ", response?.data?.access_token)

            if (response?.status == 1) {
                Swal.fire({
                    title: "Good job!",
                    text: response?.msg,
                    icon: "success"
                });
                setLoginStatus({ status: 1, msg: response?.msg });
                // Store access token and user data
                setStore({
                    'is_login': response?.data?.is_login,
                    'expiry': response?.data?.expiry,
                    'access_token': response?.data?.access_token,
                    'user_code': response?.data?.user_code,
                    'user_type': response?.data?.user_type,
                    'full_name': response?.data?.full_name,
                    'email_id': response?.data?.email_id,
                    'mobile_number': response?.data?.mobile_number,
                    'user_image': response?.data?.user_image,
                });

                // Reset form
                setFormData({
                    username: '',
                    password: ''
                });

                window.location.reload();
            } else {
                Swal.fire({
                    title: "Sorry!",
                    text: response?.msg || "Login failed",
                    icon: "error"
                });
                // Keep LoginStatus as 0 on failure (don't set to object)
            }
        } catch (e) {
            console.error('Login error:', e);
            Swal.fire({
                title: "Sorry!",
                text: e.message || "An error occurred",
                icon: "error"
            });
            // Keep LoginStatus as 0 on error (don't set to object)
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setNavBg(true);
            } else {
                setNavBg(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <header>
                <nav className={`navbar navbar-expand-lg navbar-dark navbar-custom fixed-top w-100 ${navBg ? "nav-scrolled" : ""}`}>
                    <div className="container-fluid">
                        <a className="navbar-brand d-flex align-items-center" href="/">
                            <img src={logo} alt="logo" className="logo" />
                        </a>

                        <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
                            <ul className="navbar-nav gap-0">
                                <li className="nav-item">
                                    <a class="nav-link" href="/">Home</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link fw-semibold" href="/about" id="aboutDropdown">About Us</a>
                                    {/* <ul class="dropdown-menu" aria-labelledby="aboutDropdown">
                                        <li><a class="dropdown-item" href="/infrastructure">Club Infrastructure</a></li>
                                    </ul> */}
                                </li>
                                <li className="nav-item">
                                    <a class="nav-link" href="/infrastructure">Infrastructure</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link fw-semibold" href="/alumni">Alumni</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link fw-semibold" href="/gallery">Gallery</a>
                                </li>
                                <li className="nav-item">
                                    <a class="nav-link" href="/almamater">Alma Mater</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link fw-semibold" href="/contact">Contact Us</a>
                                </li>
                            </ul>
                        </div>
                        <div className='header-btn-group'>
                            {
                                !LoginStatus ?
                                    <>
                                        <a href="#" className="login-btn" data-bs-toggle="modal" data-bs-target="#loginModal">
                                            Login <img src={`${REACT_APP_BRANDURL}theme/assets/images/login-icon.svg`} alt="login" />
                                        </a>
                                        <a href="/registration" className="login-btn register-btn">New Member <img src={memberIcon} /></a>
                                    </>
                                    : <div className="dropdown user-dropdown">
                                        <button
                                            className="btn dropdown-toggle d-flex align-items-center"
                                            type="button"
                                            id="userDropdown"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <span style={{ background: '#ffffff', padding: "3px", borderRadius: "50%", display: 'inline-flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ccc' }}>
                                                <img
                                                    style={{ width: '30px', height: '30px', borderRadius: '50%', objectFit: 'cover' }}
                                                    src={store_data?.user_image ? `${process.env.REACT_APP_APIBRANDURL}${store_data.user_image}` : `${REACT_APP_BRANDURL}theme/assets/images/intersect.png`}
                                                    alt="User"
                                                    onError={(e) => { e.target.src = `${REACT_APP_BRANDURL}theme/assets/images/intersect.png`; }}
                                                />
                                            </span>
                                            <span className='ms-2' style={{ fontFamily: "inter-regular", fontWeight: 500 }}>
                                                {store_data?.full_name || 'User'}
                                            </span>
                                        </button>
                                        <ul className="dropdown-menu dropdown-menu-end header-popup" aria-labelledby="userDropdown" style={{ minWidth: '180px' }}>
                                            <li>
                                                <div className="dropdown-item-text px-3 py-2" style={{ borderBottom: '1px solid #ffffff' }}>
                                                    <small className="text-muted ">Signed in as</small>
                                                    <div className='email'>{store_data?.email_id || ''}</div>
                                                </div>
                                            </li>
                                            <li><hr className="dropdown-divider m-0" /></li>
                                            <li>
                                                {/* <a className="dropdown-item py-2 change-password" href="/"><i className="fas fa-key me-2"></i> Change Password</a> */}
                                                <a className="dropdown-item py-2 logout-btn" href="/logout"><i className="fas fa-sign-out-alt me-2"></i> Logout</a>
                                            </li>
                                        </ul>
                                    </div>
                            }
                        </div>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </div>
                </nav>
            </header>
            <div className="modal fade" id="loginModal" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content login-modal">
                        <button type="button" className="btn-close position-absolute top-0 end-0 m-3" style={{ zIndex: 10 }} data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body p-5">
                            <h2 className="login-title text-center">Welcome Back</h2>
                            <p className="login-subtitle text-center">
                                Sign in to stay connected and explore your exclusive member features.
                            </p>
                            <img className="img-fluid" src={`${REACT_APP_BRANDURL}theme/assets/images/line.png`} alt="" />
                            <form className="mt-4" onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
                                <label className="form-label">Enter your email</label>
                                <input
                                    type="email"
                                    className="form-control login-input"
                                    placeholder="enter your email"
                                    name="username"
                                    value={FormData.username}
                                    onChange={handleChange}
                                />
                                <label className="form-label mt-4">Enter your password</label>
                                <input
                                    type="password"
                                    className="form-control login-input"
                                    placeholder="Enter password"
                                    name="password"
                                    value={FormData.password}
                                    onChange={handleChange}
                                />
                                {/* {LoginStatus && (
                                    <div className={`alert alert-${LoginStatus.status === 1 ? 'success' : 'danger'} mt-3`}>
                                        {LoginStatus.msg}
                                    </div>
                                )} */}
                                <button
                                    type="button"
                                    className="btn login-submit-btn w-100 mt-5"
                                    onClick={handleLogin}
                                    disabled={Loading}
                                >
                                    {Loading ? 'LOGGING IN...' : 'LOGIN'}
                                </button>
                            </form>
                            <div className="text-center mt-3">
                                <button className="btn py-0 px-0 forgot-link" style={{ marginLeft: 0, padding: '6px 16px', fontWeight: 600 }} onClick={() => {
                                    // Close the Bootstrap login modal first to release focus trap
                                    const loginModal = document.getElementById('loginModal');
                                    if (loginModal) {
                                        const bsModal = window.bootstrap?.Modal?.getInstance(loginModal);
                                        if (bsModal) {
                                            bsModal.hide();
                                        }
                                    }
                                    setShowForgotModal(true);
                                }}><img src={`${REACT_APP_BRANDURL}theme/assets/images/icon/password-icon.svg`} alt="password" /> Forgot Password</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Forgot Password Modal - Placed after login modal to ensure proper z-index stacking */}
            {showForgotModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ background: '#fff', padding: 32, borderRadius: 8, minWidth: 320, maxWidth: 400, boxShadow: '0 2px 16px rgba(0,0,0,0.2)', position: 'relative' }}>
                        <button onClick={() => setShowForgotModal(false)} style={{ position: 'absolute', top: 8, right: 12, border: 'none', background: 'none', fontSize: 22, cursor: 'pointer' }}>&times;</button>
                        <h5 className="mb-3">Reset Password</h5>
                        <form onSubmit={handleForgotSubmit}>
                            <div className="mb-3">
                                <label htmlFor="forgotEmail" className="form-label">Registered Email: <span className="text-danger">*</span></label>
                                <input type="email" className="form-control" id="forgotEmail" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} required autoFocus />
                            </div>
                            {forgotError && <div className="alert alert-danger py-1">{forgotError}</div>}
                            {forgotSuccess && <div className="alert alert-success py-1">{forgotSuccess}</div>}
                            <button type="submit" className="btn btn-primary w-100" disabled={forgotLoading || forgotCooldown > 0}>
                                {forgotLoading ? 'Processing...' : forgotCooldown > 0 ? `Resend in ${forgotCooldown}s` : 'Send Reset Email'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
            
            {/* Change Password Modal */}
            {showChangePasswordModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ background: '#fff', padding: 32, borderRadius: 8, minWidth: 420, maxWidth: 500, boxShadow: '0 2px 16px rgba(0,0,0,0.2)', position: 'relative', maxHeight: '90vh', overflowY: 'auto' }}>
                        <button onClick={() => setShowChangePasswordModal(false)} style={{ position: 'absolute', top: 8, right: 12, border: 'none', background: 'none', fontSize: 22, cursor: 'pointer' }}>&times;</button>
                        <h5 className="mb-3">Change Password</h5>
                        <form onSubmit={handleChangePasswordSubmit}>
                            {/* Current Password */}
                            <div className="mb-3">
                                <label className="form-label">Current Password <span className="text-danger">*</span></label>
                                <div className="input-group">
                                    <input
                                        type={showPasswords.old ? "text" : "password"}
                                        name="old_password"
                                        value={changePasswordData.old_password}
                                        onChange={handleChangePasswordInputChange}
                                        className="form-control"
                                        placeholder="Enter your current password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => togglePasswordVisibility('old')}
                                    >
                                        <i className={`fas ${showPasswords.old ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </button>
                                </div>
                            </div>

                            {/* New Password */}
                            <div className="mb-3">
                                <label className="form-label">New Password <span className="text-danger">*</span></label>
                                <div className="input-group">
                                    <input
                                        type={showPasswords.new ? "text" : "password"}
                                        name="new_password"
                                        value={changePasswordData.new_password}
                                        onChange={handleChangePasswordInputChange}
                                        className="form-control"
                                        placeholder="Enter new password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => togglePasswordVisibility('new')}
                                    >
                                        <i className={`fas ${showPasswords.new ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </button>
                                </div>
                                <small className="text-muted">Password must be at least 6 characters long</small>
                            </div>

                            {/* Confirm Password */}
                            <div className="mb-3">
                                <label className="form-label">Confirm New Password <span className="text-danger">*</span></label>
                                <div className="input-group">
                                    <input
                                        type={showPasswords.confirm ? "text" : "password"}
                                        name="current_password"
                                        value={changePasswordData.current_password}
                                        onChange={handleChangePasswordInputChange}
                                        className="form-control"
                                        placeholder="Confirm new password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={() => togglePasswordVisibility('confirm')}
                                    >
                                        <i className={`fas ${showPasswords.confirm ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                    </button>
                                </div>
                            </div>

                            <div className="d-flex gap-2">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowChangePasswordModal(false)}>Cancel</button>
                                <button
                                    type="submit"
                                    className="btn btn-primary flex-fill"
                                    disabled={changePasswordLoading}
                                >
                                    {changePasswordLoading ? 'Updating...' : 'Update Password'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    )
}
